<template>
    <div id="app">
        <transition :name="transitionName" mode="out-in">
            <router-view></router-view>
        </transition>
    </div>
</template>

<script>
import axios from 'axios'
import { Base64 } from 'js-base64'
import getQueryVariable from '@/repayment/services/getQueryVariable'
export default{
    name:'App',
    data(){
        return{
            transitionName:'slide-left',
        }
    },
    watch:{
        '$route'(to,from){
            if(to.path==='/login'){
                axios.defaults.headers.common['appId'] = Base64.decode(getQueryVariable("a"));
                axios.defaults.headers.common['token'] ='';
            }
        }
    },
    methods:{

    },
    components:{

    },
    mounted(){

    }
}
</script>
<style rel="stylesheet" lang="scss">
    @import 'scss/style';
    @import 'scss/commom';
</style>



// WEBPACK FOOTER //
// src/repayment/App.vue